var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3617 4.30371C12.0261 2.83593 14.2115 1.9438 16.604 1.9438C21.8148 1.9438 26.0462 6.17523 26.0462 11.386C26.0462 16.5969 21.8148 20.8283 16.604 20.8283C14.2115 20.8283 12.0261 19.9362 10.3617 18.4684C9.95793 18.1115 9.3393 18.1493 8.98245 18.5543C8.6256 18.9581 8.66467 19.5754 9.06841 19.9323C11.078 21.7061 13.7166 22.7819 16.604 22.7819C22.8932 22.7819 27.9998 17.6752 27.9998 11.386C27.9998 5.09686 22.8932 -0.00976562 16.604 -0.00976562C13.7166 -0.00976562 11.078 1.066 9.06841 2.83984C8.66467 3.19669 8.6256 3.81402 8.98245 4.21775C9.3393 4.62279 9.95793 4.66056 10.3617 4.30371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1094 5.65647V10.866C15.1094 11.1252 15.2123 11.3739 15.3959 11.5562L19.5635 15.7239C19.9438 16.1055 20.5637 16.1055 20.944 15.7239C21.3256 15.3436 21.3256 14.7236 20.944 14.3433L17.0629 10.4609V5.65647C17.0629 5.11729 16.6253 4.67969 16.0862 4.67969C15.547 4.67969 15.1094 5.11729 15.1094 5.65647Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976784 7.80513H8.79105C9.33024 7.80513 9.76784 7.36753 9.76784 6.82835C9.76784 6.28916 9.33024 5.85156 8.79105 5.85156H0.976784C0.437599 5.85156 0 6.28916 0 6.82835C0 7.36753 0.437599 7.80513 0.976784 7.80513Z",
    fill: "#1361F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27756 12.3618H10.0918C10.631 12.3618 11.0686 11.9242 11.0686 11.385C11.0686 10.8458 10.631 10.4082 10.0918 10.4082H2.27756C1.73838 10.4082 1.30078 10.8458 1.30078 11.385C1.30078 11.9242 1.73838 12.3618 2.27756 12.3618Z",
    fill: "#1361F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58225 16.9204H11.3965C11.9357 16.9204 12.3733 16.4828 12.3733 15.9436C12.3733 15.4044 11.9357 14.9668 11.3965 14.9668H3.58225C3.04307 14.9668 2.60547 15.4044 2.60547 15.9436C2.60547 16.4828 3.04307 16.9204 3.58225 16.9204Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSicon1);
export default __webpack_public_path__ + "static/media/quick_sicon1.a1931e9534fd693221d8a370ee5fa642.svg";
export { ForwardRef as ReactComponent };